import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import { tokenStorage } from '@/utils/storage'

const request = axios.create({
  baseURL: 'http://47.108.21.146:7777/',
  // baseURL: 'http://127.0.0.1:7777/'
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    console.log('请求拦截器 - 请求URL:', config.url)
    console.log('请求拦截器 - 请求方法:', config.method)
    console.log('请求拦截器 - 请求数据:', config.data)
    
    // 对于登录请求，不添加token
    if (config.url && config.url.includes('/login')) {
      console.log('请求拦截器 - 登录请求，跳过token添加')
      console.log('请求拦截器 - 登录请求完整URL:', config.baseURL + config.url)
    } else {
      // 使用统一的tokenStorage来获取token
      const token = tokenStorage.getToken()
      console.log('请求拦截器 - 获取到的token:', token) // 调试用
      console.log('请求拦截器 - token长度:', token ? token.length : 0) // 调试用

      if (token && token.trim() !== '') {
        // 根据后端要求设置token格式
        config.headers.Authorization = `Bearer ${token}`
        config.headers.token = token
        console.log('请求拦截器 - 设置headers完成')
      } else {
        console.log('请求拦截器 - 没有有效token')
      }
    }

    // 所有接口都不设置超时时间限制
    config.timeout = 0 // 0表示无超时限制
    console.log('设置无超时限制用于:', config.url)

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    console.log('响应拦截器 - 响应状态:', response.status)
    console.log('响应拦截器 - 响应数据:', response.data)
    
    if (response.config && ['blob', 'arraybuffer'].includes(response.config.responseType)) {
      return response.data
    }

    const { code, msg, data } = response.data

    if (code === 200) {
      console.log('响应拦截器 - 请求成功')
      return data
    } else if (code === 401) {
      console.log('响应拦截器 - 401未授权，清除token')
      Message.error('登录已过期，请重新登录')
      tokenStorage.removeToken()
      router.push('/login')
      return Promise.reject(new Error(msg))
    } else {
      console.log('响应拦截器 - 请求失败，错误码:', code, '错误信息:', msg)
      Message.error(msg || '请求失败')
      return Promise.reject(new Error(msg))
    }
  },
  error => {
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      Message.error('请求超时，请稍后重试或联系管理员')
    } else if (error.response && error.response.status === 401) {
      Message.error('登录已过期，请重新登录')
      tokenStorage.removeToken()
      router.push('/login')
    } else {
      Message.error(error.message || '网络错误')
    }
    return Promise.reject(error)
  }
)

export default request



// WEBPACK FOOTER //
// ./src/api/request.js